import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {UserSubscription} from "../../../../../user/user-subscription";

@Component({
    selector: 'db-create-website-install-footer',
    templateUrl: './create-website-install-footer.component.html',
    styleUrls: ['./create-website-install-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreateWebsiteInstallFooterComponent {

  @Input() loading = false;
  @Input() hostedWebsitesCount: number;
  @Input() hostedWebsitesLimit: number;
  @Input() isClone = false;
  @Output() readonly submitted = new EventEmitter<void>();
  @Input() userSubscription: UserSubscription;

}
